import { useLocation } from 'react-router-dom'

import { type LandingLocale, parseLocalePath } from './locale'

export function useLandingLocale(): LandingLocale {
    const { pathname } = useLocation()
    return parseLocalePath(pathname).locale
}

export function useLocaleFreePathname(): string {
    const { pathname } = useLocation()
    return parseLocalePath(pathname).pathname
}
